import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import arrowLeft from "./assets/global_assets/dashboard_imgs/sidebarClose.png"
import arrowRight from "./assets/global_assets/dashboard_imgs/sidebarOpen.png"
import { jwtDecode } from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import {Global_routes} from "./routes/Global_routes"
import {Audit_routes} from "./routes/Audit_routes"
import {Register_routes} from "./routes/Register_routes"
import Footer from './modules/global/footer/footer';
import Login from './modules/global/auth/Login/login';
import Loader from './modules/global/loader/loader';
import NotFound from './modules/global/notFound/NotFoundPage';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Navbar from './modules/global/navbar/Navbars';
import AuditNavBar from "./modules/audit/auditNavbar/AuditNavBar";
import { setUser } from './services/global_redux/globale_actions/Login.action';
import { getUserRole } from "./services/global_redux/globale_actions/Role.action";
import Sidebar from './modules/global/SideNavBar/SideBar';
import DashboardModal from './modules/global/dashboard/DashboardModal';
import { getCompanyDetails} from "./services/global_redux/globale_actions/CompanyDetails.action"
import Dashboard from './modules/global/dashboard/dashboard';
import CompanyDetails from './modules/global/CompanyDetails/CompanyDetails'
import ChangePassword from './modules/global/auth/ChangePassword/ChangePassword';
import AllCompanyDetails from './modules/global/CompanyDetails/AllCompanyDetails'
import UpdateCompanyDetails from './modules/global/CompanyDetails/UpdateCompanyDetails'


import AuditDashboard from './modules/audit/auditDashboard/AuditDashboard'
import Act from './modules/global/ActRoleActivitySetup/Act/Act';
import Rule from './modules/global/ActRoleActivitySetup/Rule/Rule';
import Activity from './modules/global/ActRoleActivitySetup/Activity/Activity';
import VendorLogin from './modules/audit/Vendor_auth/vendorLogin';
import Template from './modules/global/ActRoleActivitySetup/Template/Template';
import ChatWidget from './modules/global/AIAssistant/ChatWidget';
import { ClientTourProvider } from './modules/global/userGuide/ClientLiveTour';
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [loading, setLoading] = useState(false);
    const [logger, setlogger] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [permissionsSections, setPermissionsSections] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [currentCompany, setcurrentCompany] = useState(null);
    const [currentTab, setCurrentTab] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const use_company_code = JSON.parse(sessionStorage.getItem('user'));
    const currentUserBaseRole = use_company_code?.base_role;
    useEffect(() => {
        const user = sessionStorage.getItem('user');
        if (user) {
          const parsedClientArray = JSON.parse(user);
          setcurrentCompany(parsedClientArray.company_code);
        }},[])

    useEffect(() => {
        const container = document.querySelector(".mainbody");
        if (!container) return;

        // Remove existing highlights
        const marks = container.querySelectorAll("mark");
        marks.forEach((mark) => {
        const parent = mark.parentNode;
        parent.replaceChild(document.createTextNode(mark.textContent), mark);
        parent.normalize();
        });

        if (!searchQuery.trim()) return;

        // Highlight all matching text
        const regex = new RegExp(searchQuery, "gi");

        const walk = (node) => {
        if (node.nodeType === 3) { // text node
            const match = node.nodeValue.match(regex);
            if (match) {
            const span = document.createElement("span");
            span.innerHTML = node.nodeValue.replace(
                regex,
                `<mark style="background-color: #fff3cd; padding: 0 2px; border-radius: 2px;">$&</mark>`
            );
            node.parentNode.replaceChild(span, node);
            }
        } else if (node.nodeType === 1 && node.childNodes && !["SCRIPT", "STYLE", "MARK"].includes(node.tagName)) {
            node.childNodes.forEach(walk);
        }
        };

        walk(container);
    }, [searchQuery]);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    const showSnackbar = (message, severity, duration = 6000) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
        setTimeout(() => {
            setSnackbarOpen(false);
        }, duration);
    };
 
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedUser = sessionStorage.getItem('user');
        if (!storedToken && location.pathname != "/login" && location.pathname != "/vendor/login") {
            sessionStorage.removeItem('dashboardAlertShown');
            sessionStorage.removeItem('selectedClient');
            navigate('/login');
        }
        if (storedToken) {
            try {
                const decodedToken = jwtDecode(storedToken);
                if (decodedToken.exp > Date.now() / 1000) {
                    setIsLoggedIn(true);
                    setlogger(1)
                    if (storedUser) {
                        dispatch(setUser(JSON.parse(storedUser)));
                    } else {
                        setlogger(2)
                        localStorage.removeItem('token');
                        sessionStorage.removeItem('token');
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('dashboardAlertShown');
                        sessionStorage.removeItem('selectedClient');
                        sessionStorage.removeItem('selectedAudit');
                        setIsLoggedIn(false)
                        navigate('/login')
                    }
                } else {
                    setlogger(2)
                    localStorage.removeItem('token');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('dashboardAlertShown');
                    sessionStorage.removeItem('selectedClient');
                    sessionStorage.removeItem('selectedAudit');
                    setIsLoggedIn(false)
                    navigate('/login')
                }
            } catch (error) {
                setlogger(2)
                localStorage.removeItem('token');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('dashboardAlertShown');
                sessionStorage.removeItem('selectedClient');
                sessionStorage.removeItem('selectedAudit');
                setIsLoggedIn(false)
                navigate('/login')
 
            }
        }
    }, [dispatch]);
    const [modalOpen, setModalOpen] = React.useState(false);
 
    useEffect(() => {
        const alertShown = sessionStorage.getItem('dashboardAlertShown');
        const user = sessionStorage.getItem('user');
        if (user ) {
            const parsedClientArray = JSON.parse(user);
            setUserRole(parsedClientArray.base_role);
            if(parsedClientArray.base_role !== "vendor" ){
                const clientIds = JSON.parse(parsedClientArray.client_and_unit);
     
     
                    if (clientIds  && clientIds.length > 1) {
                        if (!alertShown) {
                            if(parsedClientArray.base_role == "Processor" || parsedClientArray.base_role == "Client"){
                                setModalOpen(true);
                            }
                        }
                    }
                     else if (clientIds  && clientIds.length === 1) {
                        setModalOpen(false);
                        sessionStorage.setItem('dashboardAlertShown', 'true');
                        sessionStorage.setItem('selectedClient', clientIds[0].client_id);
                    }
                     else {
                        sessionStorage.setItem('dashboardAlertShown', 'true');
                        if(parsedClientArray.base_role !== "SuperiorAdmin" && parsedClientArray.base_role !== "SuperAdmin"){
                            sessionStorage.setItem('selectedClient', null);
                        }
                    }

            }else{
              sessionStorage.setItem("activeTab", "Audit");
            }
        } 
    }, []);
    const datasetModalOpen = () => {
        setModalOpen(false);
        sessionStorage.setItem('dashboardAlertShown', 'true');
    };
 
 
    const handleModalClose = () => {
        setModalOpen(false);
        sessionStorage.setItem('dashboardAlertShown', 'true');
    };
 
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
            setPermissionsSections(response.data);
        } catch (err) {
          console.error("Failed to fetch states:", err);
        }
      };
      useEffect(() => {
        getUserPermission();
      }, [dispatch]);
      const getCompanyDetailbyid = async () => {
        if(currentUserBaseRole === "vendor"){
            sessionStorage.setItem("activeTab", "Audit");
        }else{            
            try {
            const response = await dispatch(getCompanyDetails(currentCompany));
            if (response.success === true) {
                let selectedTab;
                if (response.data.services[0] === "Compliance") {
                selectedTab = response.data.services[1];
                } else {
                selectedTab = response.data.services[0];
                }
        
                const storedTab = sessionStorage.getItem("activeTab");
        
                if (storedTab) {
                setCurrentTab(storedTab);
                } else {
                sessionStorage.setItem("activeTab", selectedTab);
                setCurrentTab(selectedTab);
                }
            }
            } catch (err) {
            console.error("Failed to fetch states:", err);
            }
        }
      };
      
      
      useEffect(() => {
        const savedTab = sessionStorage.getItem("activeTab");
        if(savedTab){ 
            setCurrentTab(savedTab);
        }else if (currentCompany) {
            getCompanyDetailbyid();
        }
    }, [currentCompany]);
 
      const formatValidPermissions = (permissions) => {
        const result = {};
 
        if (permissions && typeof permissions[0] === "string") {
            try {
                permissions = JSON.parse(permissions[0]);
            } catch (e) {
                console.error("Invalid JSON format", e);
                return result;
            }
        }
        if(permissions){
            permissions.forEach(({ section, module, sub_module }) => {
                if (!section || !module) return;

                const normalizedSection = section === "Generated Forms" ? "Generated Form" : section;
                const normalizedModule = module === "Generated Forms" ? "Generated Form" : module;
 
                if (Array.isArray(sub_module)) {
                  const validSubModules = sub_module.filter(sub => sub && sub.name);
                  if (!result[normalizedSection]) result[normalizedSection] = {};
 
                  result[normalizedSection][normalizedModule] = validSubModules.length > 0
                    ? validSubModules.map(sub => sub.name)
                    : sub_module.map(sub => sub.name);
                }else {
                  if (!result[normalizedSection]) result[normalizedSection] = {};
                  result[normalizedSection][normalizedModule] = [];
                }
              });
        }
        return result;
      };
        if(isLoggedIn){
            if(currentUserBaseRole !== "vendor"){
                if (!permissionsSections || permissionsSections.length === 0) return null;
                var permissionMap = formatValidPermissions(permissionsSections.permissions);
            }
        }else{
            var permissionMap = null;
        }  


    return (
        <div className='container-fluid p-0 m-0' style={{ backgroundColor:"#f5f6fa" }}>
            {isLoggedIn ? (
                <>
                {currentUserBaseRole === "SuperiorAdmin" ? <>
                    <Navbar showSnackbar={showSnackbar} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onSearch={setSearchQuery} />
                    <div className="d-flex">
                            {isLoggedIn ?
                                <>
                                <Loader loading={loading} />
                                <Sidebar sidebarOpen={sidebarOpen} showSnackbar={showSnackbar} />
                                </>
                                :
                                <></>
                            }
                        <div className='mainbody bg-light w-100' style={{ flex: 1, overflowY: 'auto' }}>
                                <>
                                    <DashboardModal open={modalOpen} onClose={datasetModalOpen} />
                                    <Routes>
                                        <Route path="/" element={<Navigate to="/dashboard" />} />
                                        <Route path="/dashboard" element={<Dashboard />} />
                                        <Route path="/company-details" element={<AllCompanyDetails showSnackbar={showSnackbar} setLoading={setLoading} />} />
                                        <Route path="/company-details/new-company-details" element={<CompanyDetails showSnackbar={showSnackbar} setLoading={setLoading} />} />
                                        <Route path="/company-details/update/:CompanyID" element={<UpdateCompanyDetails showSnackbar={showSnackbar} setLoading={setLoading} />} />
                                        <Route path="/reset_password" element={<ChangePassword  showSnackbar={showSnackbar} setLoading={setLoading} />}/>
                                        <Route path='/act' element = {<Act showSnackbar={showSnackbar} setLoading={setLoading}/>}/>
                                        <Route path='/rule' element = {<Rule showSnackbar={showSnackbar} setLoading={setLoading}/>}/>
                                        <Route path='/activity' element = {<Activity showSnackbar={showSnackbar} setLoading={setLoading}/>}/>
                                        <Route path='/template' element = {<Template showSnackbar={showSnackbar} setLoading={setLoading}/>}/>
                                        <Route path="*" element={<NotFound />} />
                                    </Routes>
                            </>
        
                        </div>
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={6000}
                            onClose={handleSnackbarClose}
                            className='mt-5'
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                            sx={{
                                zIndex: 9999999,
                            }}
                        >
                            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
        
                    </div>

                </>
                :
                <>
                    {currentTab == "Audit" ?
                    <>
                        <div className='col-md-12'>
                        <AuditNavBar className="" showSnackbar={showSnackbar} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onSearch={setSearchQuery} />
                        </div>
                        <div className="col-md-12" style={{ height:"100%",overflowX :"hidden" }}>
                                    <Loader loading={loading} />
                                    <div
                                        className="mainbody w-100 p-3"
                                        style={{
                                            flex: 1,
                                            marginTop: "60px",
                                            overflow: "auto",
                                            position: "relative",
                                            height: "calc(100vh - 80px)",
                                        }}
                                    >
                                        <>
                                            <DashboardModal open={modalOpen} onClose={datasetModalOpen} />
                                            <Routes>
                                                {/* {Global_routes({ showSnackbar, setLoading, permissionMap })} */}
                                                {Audit_routes({ showSnackbar, setLoading, permissionMap })}
                                                <Route path="*" element={<NotFound />} />
                                            </Routes>
                                        </>

                                    </div>
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                                className='mt-5'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                sx={{
                                    zIndex: 9999999,
                                }}
                            >
                                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>

                        </div>
                    </>
                    :<>
                        {currentUserBaseRole === "Client" ? (
                        <ClientTourProvider>
                        <Navbar showSnackbar={showSnackbar} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onSearch={setSearchQuery} />
                        <div className="d-flex">
                                {isLoggedIn ?
                                    <>
                                    <Loader loading={loading} />
                                    <Sidebar sidebarOpen={sidebarOpen} showSnackbar={showSnackbar} />
                                    </>
                                    :
                                    <></>
                                }
                            <div className='mainbody bg-light w-100' style={{ flex: 1, overflowY: 'auto' }}>
                                    <>
                                        <DashboardModal open={modalOpen} onClose={datasetModalOpen} />
                                        <Routes>
                                            {Global_routes({ showSnackbar, setLoading, permissionMap })}
                                            {Register_routes({ showSnackbar, setLoading, permissionMap })}
                                            <Route path="*" element={<NotFound />} />
                                        </Routes>
                                </>

                            </div>
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                                className='mt-5'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                sx={{
                                    zIndex: 9999999,
                                }}
                            >
                                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>

                        </div>
                        </ClientTourProvider>
                        ) : (
                        <>
                        <Navbar showSnackbar={showSnackbar} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onSearch={setSearchQuery} />
                        <div className="d-flex">
                                {isLoggedIn ?
                                    <>
                                    <Loader loading={loading} />
                                    <Sidebar sidebarOpen={sidebarOpen} showSnackbar={showSnackbar} />
                                    </>
                                    :
                                    <></>
                                }
                            <div className='mainbody bg-light w-100' style={{ flex: 1, overflowY: 'auto' }}>
                                    <>
                                        <DashboardModal open={modalOpen} onClose={datasetModalOpen} />
                                        <Routes>
                                            {Global_routes({ showSnackbar, setLoading, permissionMap })}
                                            {Register_routes({ showSnackbar, setLoading, permissionMap })}
                                            <Route path="*" element={<NotFound />} />
                                        </Routes>
                                </>

                            </div>
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                                className='mt-5'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                sx={{
                                    zIndex: 9999999,
                                }}
                            >
                                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>

                        </div>
                        </>
                        )}
                    </>
                    }
                </>
                }
                </>
    
            ) : (
                <Routes>
                    <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
                    <Route path="/vendor/login" element={<VendorLogin setIsLoggedIn={setIsLoggedIn} />} />
                    <Route path="/" element={<Navigate to="/login" />} />
                </Routes>
            )}
            {isLoggedIn && <ChatWidget />}
        </div>
    );
}
 
export default App;